module.exports = __webpack_public_path__ + "img/hj-bg6.7fddfa05.jpg";